"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformApiTokenScopes = void 0;
/**
 * Scopes which can be used for limiting API tokens {@link SdPlatformResponseApiToken}.
 */
var SdPlatformApiTokenScopes;
(function (SdPlatformApiTokenScopes) {
    /**
     * Models readonly.
     */
    SdPlatformApiTokenScopes["ModelsRead"] = "models-read";
    /**
     * Models read-write.
     */
    SdPlatformApiTokenScopes["ModelsWrite"] = "models-write";
    /**
     * Models full.
     */
    SdPlatformApiTokenScopes["ModelsFull"] = "models-full";
    /**
     * Bookmarks full.
     */
    SdPlatformApiTokenScopes["BookmarksFull"] = "bookmarks-full";
    /**
     * Images readonly.
     */
    SdPlatformApiTokenScopes["ImagesRead"] = "images-read";
    /**
     * Images read-write.
     */
    SdPlatformApiTokenScopes["ImagesWrite"] = "images-write";
    /**
     * Images full.
     */
    SdPlatformApiTokenScopes["ImagesFull"] = "images-full";
    /**
     * Geometry backend tokens.
     */
    SdPlatformApiTokenScopes["Tokens"] = "tokens";
    /**
     * Tags readonly.
     */
    SdPlatformApiTokenScopes["TagsRead"] = "tags-read";
    /**
     * Tags read-write.
     */
    SdPlatformApiTokenScopes["TagsWrite"] = "tags-write";
    /**
     * Users readonly.
     */
    SdPlatformApiTokenScopes["UsersRead"] = "users-read";
    /**
     * Users read-write.
     */
    SdPlatformApiTokenScopes["UsersWrite"] = "users-write";
    /**
     * Users full.
     */
    SdPlatformApiTokenScopes["UsersFull"] = "users-full";
    /**
     * User model sessions read.
     */
    SdPlatformApiTokenScopes["UserModelSessionsRead"] = "user-model-sessions-read";
    /**
     * Organization model sessions read.
     */
    SdPlatformApiTokenScopes["OrganizationModelSessionsRead"] = "organization-model-sessions-read";
    /**
     * Model sharing readonly.
     */
    SdPlatformApiTokenScopes["ModelSharingRead"] = "model-sharing-read";
    /**
     * Model sharing read-write.
     */
    SdPlatformApiTokenScopes["ModelSharingWrite"] = "model-sharing-write";
    /**
     * Model sharing full.
     */
    SdPlatformApiTokenScopes["ModelSharingFull"] = "model-sharing-full";
    /**
     * Saved states readonly.
     */
    SdPlatformApiTokenScopes["SavedStatesRead"] = "saved-states-read";
    /**
     *  Saved states read-write.
     */
    SdPlatformApiTokenScopes["SavedStatesWrite"] = "saved-states-write";
    /**
     *  Saved states full.
     */
    SdPlatformApiTokenScopes["SavedStatesFull"] = "saved-states-full";
    /**
     * Saved state sharing readonly.
     */
    SdPlatformApiTokenScopes["SavedStateSharingRead"] = "saved-state-sharing-read";
    /**
     * Saved state sharing read-write.
     */
    SdPlatformApiTokenScopes["SavedStateSharingWrite"] = "saved-state-sharing-write";
    /**
     * Saved state sharing full.
     */
    SdPlatformApiTokenScopes["SavedStateSharingFull"] = "saved-state-sharing-full";
    /**
     * Actions full.
     */
    SdPlatformApiTokenScopes["ActionsFull"] = "actions-full";
    /**
     * Api clients full.
     */
    SdPlatformApiTokenScopes["ApiClientsFull"] = "apiclients-full";
    /**
     * Geometry backend systems full
     */
    SdPlatformApiTokenScopes["BackendSystemsFull"] = "backendsystems-full";
    /**
     * Domains read.
     */
    SdPlatformApiTokenScopes["DomainsRead"] = "domains-read";
    /**
     * Domains full.
     */
    SdPlatformApiTokenScopes["DomainsFull"] = "domains-full";
    /**
     * Http logs full.
     */
    SdPlatformApiTokenScopes["HttpLogsFull"] = "httplogs-full";
    /**
     * Policies full.
     */
    SdPlatformApiTokenScopes["PoliciesFull"] = "policies-full";
    /**
     * Organizations readonly.
     */
    SdPlatformApiTokenScopes["OrganizationsRead"] = "organizations-read";
    /**
     * Organizations read-write.
     */
    SdPlatformApiTokenScopes["OrganizationsWrite"] = "organizations-write";
    /**
     * Organizations full.
     */
    SdPlatformApiTokenScopes["OrganizationsFull"] = "organizations-full";
    /**
     * Notifications readonly.
     */
    SdPlatformApiTokenScopes["NotificationsRead"] = "notifications-read";
    /**
     * Notifications read-write.
     */
    SdPlatformApiTokenScopes["NotificationsWrite"] = "notifications-write";
    /**
     * Notifications full.
     */
    SdPlatformApiTokenScopes["NotificationsFull"] = "notifications-full";
    /**
     * Documents readonly.
     */
    SdPlatformApiTokenScopes["DocumentsRead"] = "documents-read";
    /**
     * Documents read-write.
     */
    SdPlatformApiTokenScopes["DocumentsWrite"] = "documents-write";
    /**
     * Documents full.
     */
    SdPlatformApiTokenScopes["DocumentsFull"] = "documents-full";
    /**
     *
     */
    SdPlatformApiTokenScopes["OpenidProviderFull"] = "openid-provider-full";
    /**
     * All.
     */
    SdPlatformApiTokenScopes["All"] = "*";
})(SdPlatformApiTokenScopes = exports.SdPlatformApiTokenScopes || (exports.SdPlatformApiTokenScopes = {}));
//# sourceMappingURL=SdPlatformApiTokenScopes.js.map